import { render } from "./IconCart.vue?vue&type=template&id=18dc24e6&ts=true"
import script from "./IconCart.vue?vue&type=script&lang=ts"
export * from "./IconCart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__